module.exports = __webpack_public_path__ + "static/media/Dsky.aa656bb1.png";